module.exports = __webpack_public_path__ + "img/level7.dd90a595.png";